/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pricerangeslider_Minprice3Inputs */

const id_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga min`)
};

const ms_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga min`)
};

const da_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. pris`)
};

const de_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestpreis`)
};

const en_us2_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

const es_es2_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio mín`)
};

const es_mx2_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio mín.`)
};

const fil_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min na presyo`)
};

const fr_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix min`)
};

const it_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo min`)
};

const hu_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min ár`)
};

const nl_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min prijs`)
};

const no_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min pris`)
};

const pl_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena min`)
};

const pt_br2_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

const pt_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço mín`)
};

const ro_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preț min`)
};

const fi_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min hinta`)
};

const sv_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min pris`)
};

const vi_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá tối thiểu`)
};

const tr_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. fiyat`)
};

const cs_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. cena`)
};

const bg_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мин. цена`)
};

const ru_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мин. цена`)
};

const uk_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мін. ціна`)
};

const ar_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحد الأدنى`)
};

const hi_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम मूल्य`)
};

const th_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ราคาต่ำสุด`)
};

const ja_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低価格`)
};

const zh_cn2_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

const zh_hant1_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

const ko_ui_pricerangeslider_minprice3 = /** @type {(inputs: Ui_Pricerangeslider_Minprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min price`)
};

/**
* | output |
* | --- |
* | "Min price" |
*
* @param {Ui_Pricerangeslider_Minprice3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_pricerangeslider_minprice3 = /** @type {((inputs?: Ui_Pricerangeslider_Minprice3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pricerangeslider_Minprice3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_pricerangeslider_minprice3(inputs)
	if (locale === "ms") return ms_ui_pricerangeslider_minprice3(inputs)
	if (locale === "da") return da_ui_pricerangeslider_minprice3(inputs)
	if (locale === "de") return de_ui_pricerangeslider_minprice3(inputs)
	if (locale === "en-US") return en_us2_ui_pricerangeslider_minprice3(inputs)
	if (locale === "es-ES") return es_es2_ui_pricerangeslider_minprice3(inputs)
	if (locale === "es-MX") return es_mx2_ui_pricerangeslider_minprice3(inputs)
	if (locale === "fil") return fil_ui_pricerangeslider_minprice3(inputs)
	if (locale === "fr") return fr_ui_pricerangeslider_minprice3(inputs)
	if (locale === "it") return it_ui_pricerangeslider_minprice3(inputs)
	if (locale === "hu") return hu_ui_pricerangeslider_minprice3(inputs)
	if (locale === "nl") return nl_ui_pricerangeslider_minprice3(inputs)
	if (locale === "no") return no_ui_pricerangeslider_minprice3(inputs)
	if (locale === "pl") return pl_ui_pricerangeslider_minprice3(inputs)
	if (locale === "pt-BR") return pt_br2_ui_pricerangeslider_minprice3(inputs)
	if (locale === "pt") return pt_ui_pricerangeslider_minprice3(inputs)
	if (locale === "ro") return ro_ui_pricerangeslider_minprice3(inputs)
	if (locale === "fi") return fi_ui_pricerangeslider_minprice3(inputs)
	if (locale === "sv") return sv_ui_pricerangeslider_minprice3(inputs)
	if (locale === "vi") return vi_ui_pricerangeslider_minprice3(inputs)
	if (locale === "tr") return tr_ui_pricerangeslider_minprice3(inputs)
	if (locale === "cs") return cs_ui_pricerangeslider_minprice3(inputs)
	if (locale === "bg") return bg_ui_pricerangeslider_minprice3(inputs)
	if (locale === "ru") return ru_ui_pricerangeslider_minprice3(inputs)
	if (locale === "uk") return uk_ui_pricerangeslider_minprice3(inputs)
	if (locale === "ar") return ar_ui_pricerangeslider_minprice3(inputs)
	if (locale === "hi") return hi_ui_pricerangeslider_minprice3(inputs)
	if (locale === "th") return th_ui_pricerangeslider_minprice3(inputs)
	if (locale === "ja") return ja_ui_pricerangeslider_minprice3(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_pricerangeslider_minprice3(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_pricerangeslider_minprice3(inputs)
	return ko_ui_pricerangeslider_minprice3(inputs)
});
export { ui_pricerangeslider_minprice3 as "ui.priceRangeSlider.minPrice" }